<script setup>
import {onBeforeMount, onMounted, onBeforeUnmount, ref} from "vue";
import {useStore} from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";

import {toast} from "vue3-toastify";
// import bgProfile2 from "@/assets/img/bg-profile2.webp";
import router from "@/router";

const body = document.getElementsByTagName("body")[0];

const store = useStore();
import {getProfile, updateProfile} from "@/requests/user/profile/FillProfileRequest.js";
import {getProvinces, getCities} from "@/requests/user/provinces/ProvinceRequest.js";

let formData = {
  username: '',
  email: '',
  firstName: '',
  lastName: '',
  address: '',
  province: '',
  city: '',
  // password: '',
  // confirm_password: '',
};

var provinces = ref({});

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});

onBeforeMount(async () => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");

  store.state.isRTL = true;
  document.querySelector("html").setAttribute("lang", "fa");
  document.querySelector("html").setAttribute("dir", "rtl");
  document.querySelector("#app").classList.add("rtl");
  body.classList.remove("bg-gray-100");

  // user data from api and fill the form
  const profileData = await getProfile();

  console.info('formData ', formData)
  if (profileData.success) {
    formData = profileData.data;
  } else {
    toast.error('خطا در دریافت اطلاعات کاربر');
  }

  let provincesResponse = await getProvinces();
  if (provincesResponse.success) {
    provinces.value = provincesResponse.data;
  }

});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});

// const updateProfile = (itemName,event)=>{
//   console.info('itemName ' ,itemName)
//   console.info('event ' ,event)
// }

const submitForm = async () => {
  console.info('submitForm ', formData)

  let response = await updateProfile(formData);

  console.info('response ', response)
  if (response?.success) {
    toast.success(response?.message ?? 'اطلاعات پروفایل با موفقیت بروز گردید، در حال هدایت به داشبورد هستید ...');
    router.push({name: '/'});
  } else {
    toast.error(response?.message ?? 'خطا در بروز رسانی، دقایقی دیگر تلاش کنید.');
  }

}


// let invalidPassword = ref(false);
// const checkPassword = () => {
//   console.info('checkPassword ', formData.password, formData.confirm_password);
//   if (formData.password !== formData.confirm_password) {
//     // console.info('Passwords do not match');
//     // toast.error('Passwords do not match');
//     invalidPassword.value = true;
//   } else {
//     // console.info('Passwords match');
//     invalidPassword.value = false;
//
//   }
// }

const updateCities = async () => {
  console.info('updateCities ', formData.province);
  //get cities by province id
  // formData.city = '';
  let data = await getCities(formData.province);
  console.info('data ', data);
  console.info('data.cities ', data.cities);
  if (data.success) {
    //populate city select

    let citySelect = document.getElementById('city');
    citySelect.innerHTML = '';

    data.cities.forEach(city => {
      let option = document.createElement('option');
      option.value = city.id;
      option.text = city.name;
      citySelect.add(option);
    });
  }

}


let isUsernameValid = ref(false);
let usernameError = ref('');

const checkUsername = () => {
  console.info('checkUsername ', formData.username);

  // وضعیت اعتبارسنجی
  let isValid = false;
  let errorMessage = '';

  if (formData.username?.length > 0) {
    // حذف همه انواع فاصله‌ها (گسترش‌یافته برای پوشش کامل)
    formData.username = formData.username.replace(/[\s\u200C\u00A0\u200B\u202F\u2028\u2029]/g, '');
    console.log('After removing spaces:', formData.username); // دیباگ: پس از حذف فاصله

    // تبدیل حرف اول به بزرگ (فقط اگر انگلیسی باشد)
    if (formData.username.length > 0 && /[a-zA-Z]/.test(formData.username.charAt(0))) {
      formData.username = formData.username.charAt(0).toUpperCase() + formData.username.slice(1);
      console.log('After capitalizing first letter:', formData.username); // دیباگ
    }

    // حذف کاراکترهای غیرمجاز (فقط انگلیسی و اعداد مجاز)
    formData.username = formData.username.replace(/[^a-zA-Z0-9]/g, '');
    console.log('output: ', formData.username); // دیباگ: پس از حذف فارسی
    console.log('formData: ', formData); // دیباگ: پس از حذف فارسی


    document.getElementById('username').value = formData.username

    // اعتبارسنجی طول
    if (formData.username.length >= 3) {
      isValid = true;
      errorMessage = '';
    } else {
      errorMessage = 'نام کاربری باید حداقل 3 کاراکتر باشد';
    }
  } else {
    errorMessage = 'نام کاربری نمی‌تواند خالی باشد';
  }

  // به‌روزرسانی وضعیت برای نمایش در UI
  isUsernameValid.value = isValid;
  usernameError.value = errorMessage;
};

</script>

<template>
  <main>

    <div class="py-4 container-fluid">
      <form @submit.prevent="submitForm" class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <h5 class="mb-0 ms-auto">تکمیل اطلاعات اولیه حساب کاربری</h5>
              </div>
              <p>جهت فعال سازی حساب کاربری خود اطلاعات فرم زیر را تکمیل کنید.</p>
            </div>
            <div class="card-body">

              <div class="row">

                <div class="col-lg-2 col-md-2">
                  <label for="example-text-input" class="form-control-label ">جنسیت</label>
                  <select class="form-select text-center mb-3" aria-label=".form-select-lg example">
                    <option value="male" selected>آقا</option>
                    <option value="female">خانوم</option>
                  </select>
                </div>

                <div class="col-lg-4 col-md-4">
                  <label for="username" class="form-control-label">نام کاربری</label>
                  <argon-input
                      type="text"
                      class="text-start"
                      v-model="formData.username"
                      @change="checkUsername"
                      id="username"
                      :class="{ 'is-valid': isUsernameValid, 'is-invalid': !isUsernameValid && usernameError }"
                  />
                  <div v-if="!isUsernameValid && usernameError" class="invalid-feedback">
                    {{ usernameError }}
                  </div>
                </div>

                <div class="col-lg-3 col-md-3">
                  <label for="example-text-input" class="form-control-label">نام</label>
                  <argon-input type="text" v-model="formData.first_name"/>
                </div>

                <div class="col-lg-3 col-md-3">
                  <label for="example-text-input" class="form-control-label">نام خانوادگی</label>
                  <argon-input type="text" v-model="formData.last_name" value=""/>
                </div>

              </div>

              <div class="row">

                <div class="col-lg-3 col-md-2">
                  <label for="province" class="form-control-label">استان</label>
                  <select class="form-select text-center mb-3" v-model="formData.province" @change="updateCities"
                          id="province"
                          aria-label=".form-select-lg example">

                    <template v-if="provinces.length > 0">
                      <option v-for="province in provinces" :key="province.id" :value="province.id">
                        {{ province.name }}
                      </option>
                    </template>
                  </select>
                </div>

                <div class="col-lg-3 col-md-2">
                  <label for="city" class="form-control-label">شهر</label>
                  <select class="form-select text-center mb-3" v-model="formData.city" id="city"
                          aria-label=".form-select-lg example">
                  </select>
                </div>


                <div class="col-lg-6 col-md-12">
                  <!--                    <label for="example-text-input" class="form-control-label"></label>-->
                  <argon-textarea type="text" rows="1" class="" v-model="formData.address" id="address"
                                  placeholder="آدرس محل سکونت خود را وارد کنید">
                    آدرس
                  </argon-textarea>
                </div>

<!--                <div class="col-lg-4 col-md-6">-->
<!--                  <label for="password" class="form-control-label">رمز عبور</label>-->
<!--                  <argon-input type="password" @input="checkPassword"-->
<!--                               :class="invalidPassword && formData.password?.length > 0 ? 'is-invalid' : ''"-->
<!--                               class="text-start" v-model="formData.password" id="password"/>-->
<!--                </div>-->

<!--                <div class="col-lg-4 col-md-6">-->
<!--                  <label for="confirm_password" class="form-control-label">تکرار رمز عبور</label>-->
<!--                  <argon-input type="password" @input="checkPassword"-->
<!--                               :class="invalidPassword && formData.confirm_password?.length > 0 ? 'is-invalid' : ''"-->
<!--                               class="text-start" v-model="formData.confirm_password" id="password"/>-->
<!--                </div>-->

                <template v-if="invalidPassword && formData.password?.length > 0">
                  <small class="text-danger mt-n2 mb-3"> رمز عبور و تکرار رمز عبور مطابقت ندارند</small>
                </template>

              </div>

              <div class="row">
                <argon-button color="success" size="sm" class="w-auto" type="submit">بروزرسانی</argon-button>
              </div>
              <!--              <hr class="horizontal dark" />-->
              <!--              <p class="text-uppercase text-sm">درباره من</p>-->
              <!--              <div class="row">-->
              <!--                <div class="col-md-12">-->
              <!--                  <label for="example-text-input" class="form-control-label"-->
              <!--                    >درباره من</label-->
              <!--                  >-->
              <!--                  <argon-input-->
              <!--                    type="text"-->
              <!--                    value="A beautiful Dashboard for Bootstrap 5. It is Free and Open Source."-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>

      </form>
    </div>
  </main>
</template>
